module.exports = __webpack_public_path__ + "media/images/vr/promo-experiencias-section-bg-m-e703142cfd6519ea02895a620dbe8e52.jpg";